/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef, Fragment } from 'react';
import MainHeader from "../../../../Shared/components/Header";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import clsx from 'clsx';
import { Button, TextField, Box, FormControlLabel, Switch } from "@mui/material";
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space, Typography } from "antd";
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { NavLink } from "react-router-dom";
import DeleteModal from "../../../../Shared/components/DeleteModal";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import addressActions from "../../../../Admin/Address/redux/actions";
import crudActions from "../../../../CRUD/redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { emptyValidation } from "../../../../../helpers/validation";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission, idNamingConversion } from '../../../../../helpers/utilities';
import usePrevious from "../../../../Shared/components/Previous";
import ClearIcon from "../../../../../assets/images/icon_actions/Clear Icon.svg";
import actions from "../../../../Product/Setup/redux/actions";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import { ListTable } from './ListTable';
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";


const Location = (props) => {
    const { history } = props;
    const { roleManagement } = useSelector(state => state.authReducer);
    const { locationDetails, locationLoader } = useSelector(state => state.productSetupReducer);
    const { cityDetails, pincodeDetails, countryDetails, stateDetails, areaDetails } = useSelector(state => state.addressReducer);
    const { createDetails, createError, createLoader, getList, getData, editDetails, editError, editLoader } = useSelector(state => state.crudReducer);
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [importVisible, setImportVisible] = useState(false);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [form, setForm] = useState({});
    const [error, setError] = useState({});
    const [addMore, setAddMore] = useState(false);
    const [view, setView] = useState(false);
    const [visible, setVisible] = useState(false);
    const classes = customStyles();

    const dispatch = useDispatch();

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: actions.LOCATION_DETAILS_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'locations',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const prevGetData = usePrevious(getData);
    useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData.length > 0) {
                    setLoadMore(true);
                    if (getData.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Location', history, 'Product')) {
                loadTasks();
            }
        }
        return () => {
            dispatch({ type: addressActions.CLEAR_ADDRESS_DETAILS_START });
        };
    }, [roleManagement]);

    const loadTasks = useCallback(() => {
        dispatch({
            type: addressActions.STATE_DETAILS_START, url: 'state', filter: {
                order: 'id desc'
            }
        });
        dispatch({
            type: addressActions.COUNTRY_DETAILS_START, url: 'country', filter: {
                order: 'id desc'
            }
        });
        dispatchFilter(sortBy, sortOrder);
    });

    useEffect(() => {
        if ((prevSearch !== undefined && search && search.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
        }

        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'locations',
            skip: skip,
            filter: {
                where: !filter.or || filter.or.length === 0 ? {} : filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip
            },
        });
    }

    const onHandle = (data, view, visible) => {
        setForm(data);
        if (data?.stateId) {
            changeStateApi(data?.stateId);
        }

        if (data.pincodeId) {
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: data.pincodeId }] }
                }
            });
        }
        setVisible(visible);
        setView(view);
    };

    const handleAddMore = (e) => {
        createLocation(e);
        setAddMore(true);
    }

    const changeHandler = (e, name = '') => {
        setForm({
            ...form,
            [e.target.name]: e.target.value,
        });
    }

    const onDelete = (data) => {
        setDeleteModal(true);
        setForm(data);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            dispatchFilter(sortBy, sortOrder);
            onHandle({}, false, false);
            toast.dismiss();
            // toast(`"${form.name}" has been updated successfully`);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let text = editError.error.message;
            setError({
                ...error,
                "name": text
            })
        }
    }, [editDetails, editError]);

    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            onHandle({}, false, false);
            toast.dismiss();
            // toast(`"${createData.name}" has been added successfully`);
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let text = createError.error.message;
            setError({
                ...error,
                "name": text
            })
        }
    }, [createDetails, createError]);

    const createLocation = (e) => {
        e.preventDefault();
        let emptyName = emptyValidation('Name', form.name);
        setError({});
        if (emptyName.isValid) {
            let subForm = { ...form };
            delete subForm.area; delete subForm.state; delete subForm.city; delete subForm.createdBy; delete subForm.updatedBy; delete subForm.country; delete subForm.pincode;
            if (subForm?.areaId === '' || subForm?.areaId === null) { subForm.areaId = 0 }
            dispatch({
                type: subForm?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: "locations",
                title: "Location",
                id: subForm?.id,
                details: subForm,
            })
        } else {
            setError({
                'name': emptyName.errors
            });
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const changeState = (value) => {
        let data = {
            ...form, stateId: value, cityId: '', pincodeId: '', areaId: ''
        }
        let a = stateDetails && stateDetails.filter((el) => { return el.id === value });
        if (a && a?.length !== 0) {
            data.countryId = a[0].countryId;
        }
        setForm(data)
        changeStateApi(value);
    }

    const changeStateApi = (value) => {
        dispatch({
            type: addressActions.PINCODE_DETAILS_START, url: 'pincode', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
        dispatch({
            type: addressActions.CITY_DETAILS_START, url: 'city', filter: {
                where: { ["and"]: [{ stateId: value }] }
            }
        });
    }

    const changePincode = (value) => {
        let data = {
            ...form, pincodeId: value, areaId: ''
        }
        let a = pincodeDetails && pincodeDetails.filter((el) => { return el.id === value });
        if (a && a?.length !== 0) {
            data.cityId = a[0].cityId
            dispatch({
                type: addressActions.AREA_DETAILS_START, url: 'areas', filter: {
                    where: { ["and"]: [{ pincodeId: value }] }
                }
            });
        }
        setForm(data);
    }

    return (
        <Fragment>
            <MainHeader {...props} img={SettingsImg}
                title={'Product'} links={[{ 'label': 'Product', 'link': '/product' }, { 'label': 'Location', 'link': '' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Location'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Location', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation || search !== '' })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search Location and Name'
                                                type='search'
                                                value={search}
                                                onChange={(e) => setSearch(e.target.value)}
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                fullWidth
                                                id={idNamingConversion('Search', 'location', 'TextField')}
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                            {
                                                search && <NavLink to="#" onClick={() => setSearch('')} className={classes.searchClear}>
                                                    <Image
                                                        src={ClearIcon}
                                                        preview={false}
                                                    />
                                                </NavLink>
                                            }
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.vertiCalScrollOverFlowParent)}>
                                    <div className={classes.vertiCalScrollOverFlow}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Location', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Export', 'location', 'Link')}
                                                    onClick={() => loadImportExportData('Location')}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Location', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Import', 'customerGroup', 'Link')}
                                                    onClick={() => setImportVisible(true)}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Location', 'create', 'Product') &&
                                                <NavLink
                                                    to="#"
                                                    id={idNamingConversion('Add New Group', 'customerGroup', 'Link')}
                                                    onClick={() => onHandle({}, false, true)}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /><span className={clsx(classes.addLink, classes.color, classes.bold)}>Add New Location</span>
                                                </NavLink>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>
                            <ListTable
                                search={search}
                                onEdit={(data, view, visible) => onHandle(data, view, visible)}
                                onDelete={(data) => onDelete(data)}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                handleOpen={() => onHandle({}, false, true)}
                                loadMoreTask={() => loadMoreTask()}
                                loadMoreContent={loadMoreContent}
                                sortOrder={sortOrder}
                                sortBy={sortBy}
                                onView={(data) => onHandle(data, true, true)}
                                roleManagement={roleManagement}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)}
                            />
                        </>
                    } />
            </div>
            <PrimaryDrawer
                anchor={'right'}
                open={visible}
                width={'495px'}
                variant={'temporary'}
                handleClose={() => onHandle({}, false, false)}
                title={`${form?.id ? `${view ? 'View' : 'Edit'}` : 'Add'} Location`}
                className={clsx(classes.closeBackGround, classes.width100P)}
                component={
                    <Box
                        className={clsx(classes.customForm, classes.removeUnderline)}
                        component="form"
                        autoComplete="off"

                        onSubmit={(e) => createLocation(e)}>
                        <div className={classes.customFormFlex}>
                            <Row gutter={25} type="flex" >
                                <Col span={20}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.fonSize13)}>Name</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.name || '---'}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label={["Name ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                                variant={'standard'}
                                                className={''}
                                                error={error.name ? true : false}
                                                helperText={error.name}
                                                name={"name"}
                                                fullWidth
                                                id={idNamingConversion('Name', 'location', 'TextField')}
                                                value={form.name}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col span={4}>
                                    <FormControlLabel
                                        classes={{
                                            label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                        }}
                                        id={idNamingConversion('Default', 'location', 'Radio')}
                                        control={<Switch size='small'
                                            className={clsx(classes.customSwitch)}
                                            onChange={(e) => setForm({ ...form, 'default': !form.default })}
                                            checked={form?.default}
                                        />}
                                        label="Default"
                                        labelPlacement="top"
                                        className={clsx(classes.marginLeft0, classes.flexStart)}
                                    />
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Address</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.address || '---'}</Typography>
                                            </> :
                                            <TextField autoComplete='one-time-code'
                                                label=''
                                                placeholder='Door/Building Number,&#10;Building Name&#10;Street Address&#10;Locality'
                                                value={form?.address || ''}
                                                variant={'outlined'}
                                                className={clsx(classes.customDescription, classes.margin30t)}
                                                fullWidth
                                                multiline
                                                rows={3}
                                                name={"address"}
                                                id={idNamingConversion('Address', 'location', 'DropDown')}
                                                InputProps={{
                                                    classes: {
                                                        input: classes.textFieldColor,
                                                    }
                                                }}
                                                InputLabelProps={{
                                                    className: classes.textFieldLableColorCustom,
                                                }}
                                                onChange={(e) => changeHandler(e)}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>State</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.state?.name || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["State/Province"]}
                                                heads={[{ 'key': 'name', 'name': 'State Name' },
                                                { 'key': 'country', 'name': 'Country Name', 'relation': 'name' }]}
                                                details={stateDetails}
                                                id={idNamingConversion('State', 'location', 'DropDown')}
                                                parentValue={customObject(stateDetails, form?.stateId)}
                                                onChange={(data) => changeState(data.id)}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Pincode</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.pincode?.code || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Pincode "]}
                                                heads={[{ 'key': 'code', 'name': 'Pincode' },
                                                { 'key': 'city', 'name': 'City', 'relation': 'name' }]}
                                                details={pincodeDetails}
                                                id={idNamingConversion('Pincode', 'location', 'DropDown')}
                                                parentValue={customObject(pincodeDetails, form?.pincodeId)}
                                                onChange={(data) => changePincode(data.id)}
                                                position={'bottom'}
                                                customClasses={classes.margin20t}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Area</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.area?.name || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Area"]}
                                                heads={[{ 'key': 'name', 'name': 'Area Name' },
                                                { 'key': 'pincode', 'name': 'Pincode', 'relation': 'code' },
                                                { 'key': 'city', 'name': 'City', 'relation': 'name' },
                                                { 'key': 'state', 'name': 'State', 'relation': 'shortName' }]}
                                                details={areaDetails}
                                                id={idNamingConversion('Area', 'location', 'DropDown')}
                                                parentValue={customObject(areaDetails, form?.areaId)}
                                                onChange={(data) => setForm({ ...form, 'areaId': data.id })}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>City</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.city?.name || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Dist/City/Town"]}
                                                heads={[{ 'key': 'name', 'name': 'Name' },
                                                { 'key': 'state', 'name': 'State Name', 'relation': 'shortName' }]}
                                                details={cityDetails}
                                                id={idNamingConversion('City', 'location', 'DropDown')}
                                                parentValue={customObject(cityDetails, form?.cityId)}
                                                onChange={(data) => setForm({
                                                    ...form, 'cityId': data.id, 'areaId': '', 'pincodeId': ''
                                                })}
                                                position={"top"}
                                                customClasses={classes.margin20t}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Country</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.country?.name || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Country"]}
                                                heads={[{ 'key': 'name', 'name': 'Country Name' }]}
                                                details={countryDetails}
                                                id={idNamingConversion('Country', 'location', 'DropDown')}
                                                parentValue={customObject(countryDetails, form?.countryId)}
                                                onChange={(data) => setForm({
                                                    ...form, 'cityId': '', 'stateId': '', 'pincodeId': '', 'areaId': '', 'countryId': data.id
                                                })}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>In-Transit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.inTransit ? 'Yes' : 'No'}</Typography>
                                            </> :
                                            <FormControlLabel
                                                classes={{
                                                    label: clsx(classes.fonSize13, classes.textFieldLableColorCustom, 'MuiInputLabel-shrink') // Pass your override css here
                                                }}
                                                id={idNamingConversion('Default', 'location', 'Radio')}
                                                control={<Switch size='small'
                                                    className={clsx(classes.customSwitch)}
                                                    onChange={(e) => setForm({ ...form, 'inTransit': !form.inTransit })}
                                                    checked={form?.inTransit}
                                                />}
                                                label="In-Transit"
                                                labelPlacement="top"
                                                className={clsx(classes.marginLeft0, classes.flexStart, classes.margin20t)}
                                            />
                                    }
                                </Col>
                                <Col span={12}>
                                    {
                                        view ?
                                            <>
                                                <Typography variant={'subtitle1'} className={clsx(classes.textFieldLableColorCustom, 'MuiInputLabel-shrink', classes.margin20t, classes.fonSize13)}>Transit</Typography>
                                                <Typography variant={'h6'} className={clsx(classes.textFieldColor, classes.fonSize14)}>{form?.transit?.name || '---'}</Typography>
                                            </> :
                                            <AutoCompleteComponent
                                                name={["Transit"]}
                                                heads={[{ 'key': 'name', 'name': 'Name' }]}
                                                details={getList ? getList?.filter(el => !el.inTransit) : []}
                                                id={idNamingConversion('Country', 'location', 'DropDown')}
                                                parentValue={customObject(getList ? getList?.filter(el => !el.inTransit) : [], form?.transitId)}
                                                onChange={(data) => setForm({
                                                    ...form, 'transitId': data.id
                                                })}
                                                position={"bottom"}
                                                customClasses={classes.margin20t}
                                            />
                                    }
                                </Col>

                            </Row>
                        </div>
                        <div className={clsx(classes.btnParent)}>
                            {
                                <Space size={[10, 10]} direction="horizontal" align="center">
                                    {
                                        !view ? <> <Button
                                            key="save"
                                            color="primary"
                                            variant="contained"
                                            type={'submit'}
                                            className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })}>
                                            {
                                                form?.id ? 'Update & Close' : 'Save & Close'
                                            }
                                        </Button>
                                            {
                                                !form?.id &&
                                                <Button
                                                    key="Add More"
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={(e) => handleAddMore(e)}
                                                    className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader })}
                                                >Add More</Button>
                                            }
                                        </> : <NavLink to={'#'} className={clsx(classes.modalBtn)} onClick={() => setView(false)}>Edit</NavLink>
                                    }
                                </Space>
                            }
                        </div>
                    </Box>
                }
            />
            <ImportExport
                handleClose={() => setImportVisible(false)}
                visible={importVisible}
                title={'Location'}
                type={"import"}
                details={locationDetails}
                loader={locationLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder); }}
            />
            <DeleteModal onClose={(v) => setDeleteModal(v)} id={form.id} loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                name={form.name} url={'locations'}
                title={'Location'} visible={deleteModal} />
        </Fragment>
    )
}

export default Location